// app_core/src/area-selector/carousel.js

import { IMAGE_PATHS } from '/settings.js';
import { getText } from '../translations/translations.js';
import { createAreaIconElement } from '../utils/icon.js';

/**
 * Renders the Carousel style selector.
 * @param {Array} areas - Array of area objects from API.
 * @param {HTMLElement} container - The content container to append to.
 * @param {Function} onSelect - Callback function when an area is selected (passes areaSlug).
 */
export async function renderCarousel(areas, container, onSelect) {
    // Create Carousel Wrapper
    const carousel = document.createElement('div');
    carousel.className = 'area-carousel';

    // Get current language for name display
    // We assume getText is available, but for dynamic DB content we might need a helper
    // or just read the correct property based on lang.
    // For now, let's try to detect lang from document or settings fallback
    const currentLang = document.documentElement.lang || 'en';
    const nameField = `name_${currentLang}`; // e.g., name_en, name_es

    areas.forEach(area => {
        const card = document.createElement('div');
        card.className = 'area-card';
        card.setAttribute('role', 'button');
        card.tabIndex = 0;

        // Click Handler
        card.onclick = () => {
            onSelect(area);
        };

        // Keyboard Accessibility
        card.onkeydown = (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onSelect(area);
            }
        };

        // Icon (area sprite)
        const iconId = (area.slug || area.icon || '').toString();
        const icon = createAreaIconElement(iconId, 'area-card-icon', 'map-location-dot-solid');

        // Name
        const title = document.createElement('h3');
        title.className = 'area-card-name';
        title.textContent = area[nameField] || area.name_en;

        card.appendChild(icon);
        card.appendChild(title);
        carousel.appendChild(card);
    });

    container.appendChild(carousel);
}

